import { z } from 'zod';

export const GetLinkCurationServiceRequestDtoSchema = z.object({
  curationId: z.string().optional(),
});

export type GetLinkCurationServiceRequest = z.infer<typeof GetLinkCurationServiceRequestDtoSchema>;

export const GetLinkCurationServiceResponseDtoSchema = z.object({
  shortLink: z.string(),
});

export type GetLinkCurationServiceResponse = z.infer<
  typeof GetLinkCurationServiceResponseDtoSchema
>;
